import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center pt-1 pb-3 md:py-3 relative">
          {/* 左側ナビゲーション - 右寄せ */}
          <nav className="hidden md:flex items-center space-x-6 mr-16 flex-1 justify-end">
            <Link
              to="/service"
              className="relative text-gray-700 hover:text-pink-beige transition-colors duration-300 font-normal text-xs py-2 px-1 group"
            >
              サービス紹介
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-pink-beige transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              to="/philosophy"
              className="relative text-gray-700 hover:text-pink-beige transition-colors duration-300 font-normal text-xs py-2 px-1 group"
            >
              理念・代表の思い
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-pink-beige transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              to="/partner"
              className="relative text-gray-700 hover:text-pink-beige transition-colors duration-300 font-normal text-xs py-2 px-1 group"
            >
              パートナー社労士
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-pink-beige transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </nav>

          {/* 中央ロゴ - PC版のみ表示、ボーダーライン上に配置 */}
          <div className="hidden md:block absolute top-full left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
            <Link to="/" className="hover:opacity-80 transition-all duration-200">
              <div className="bg-white rounded-full w-24 h-24 flex items-center justify-center">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                  alt="SrWith"
                  className="h-14 w-auto"
                />
              </div>
            </Link>
          </div>
          
          {/* 右側ナビゲーション - 左寄せ */}
          <nav className="hidden md:flex items-center space-x-6 ml-16 flex-1 justify-start">
            <Link
              to="/download"
              className="relative text-gray-700 hover:text-pink-beige transition-colors duration-300 font-normal text-xs py-2 px-1 group text-center leading-tight"
            >
              お客様の声<br />資料ダウンロード
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-pink-beige transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              to="/contact"
              className="bg-pink-beige text-white px-4 py-1.5 rounded-full hover:bg-opacity-90 hover:shadow-md transition-all duration-200 font-medium text-xs ml-2"
            >
              お問い合わせ
            </Link>
            <a
              href="https://www.sr-with.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-brown text-white px-4 py-1.5 rounded-full hover:bg-opacity-90 hover:shadow-md transition-all duration-200 font-medium text-xs"
            >
              ログイン
            </a>
          </nav>
          
          {/* モバイルメニューボタン - 非表示 */}
          <div className="md:hidden hidden">
            <button 
              onClick={toggleMenu}
              className="text-gray-700 hover:text-gray-900 focus:outline-none p-1"
              aria-label="メニューを開く"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
        
        {/* モバイルメニュー - 非表示 */}
        {false && isMenuOpen && (
          <div className="md:hidden border-t border-gray-200">
            <div className="px-2 pt-3 pb-3 space-y-1 bg-white">
              <Link 
                to="/" 
                className="block px-3 py-2 text-gray-700 hover:text-pink-beige hover:bg-gray-50 rounded-md font-normal text-sm"
                onClick={() => setIsMenuOpen(false)}
              >
                トップ
              </Link>
              <Link 
                to="/service" 
                className="block px-3 py-2 text-gray-700 hover:text-pink-beige hover:bg-gray-50 rounded-md font-normal text-sm"
                onClick={() => setIsMenuOpen(false)}
              >
                サービス紹介
              </Link>
              <Link 
                to="/philosophy" 
                className="block px-3 py-2 text-gray-700 hover:text-pink-beige hover:bg-gray-50 rounded-md font-normal text-sm"
                onClick={() => setIsMenuOpen(false)}
              >
                理念・代表の思い
              </Link>
              <Link 
                to="/partner" 
                className="block px-3 py-2 text-gray-700 hover:text-pink-beige hover:bg-gray-50 rounded-md font-normal text-sm"
                onClick={() => setIsMenuOpen(false)}
              >
                パートナー社労士
              </Link>
              <Link 
                to="/download" 
                className="block px-3 py-2 text-gray-700 hover:text-pink-beige hover:bg-gray-50 rounded-md font-normal text-sm"
                onClick={() => setIsMenuOpen(false)}
              >
                資料ダウンロード
              </Link>
              <Link 
                to="/contact" 
                className="block mx-3 my-3 px-4 py-2 bg-pink-beige text-white hover:bg-opacity-90 rounded-full font-medium text-sm text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                お問い合わせ
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;